<div class="container-fluid">
    <div class="row flex-nowrap">

        <div class="col-md-6 py-2">
            <H1>Team List</H1>
            <p>
                <form-error [form]="form"></form-error>
            </p> 
            <table class="table table-sm table-striped my-1 table-bordered">
                <thead align="center">
                    <tr>
                        <th>S.No. </th>
                        <th>FirstName</th>
                        <th>Last Name</th>
                        <th>Login Id</th>
                        <th>Role</th>
                        <th>Org</th>
                        <th align="right">Action</th>
                    </tr>
                </thead>
                <tbody align="center">
                    <tr *ngFor="let e of form.list; let i = index">
                        <td>{{pageIndex(i)}}</td>
                        <td>
                            {{e.firstName}}
                        </td>
                        <td>
                            {{e.lastName}}
                        </td>
                        <td>
                            {{e.loginId}}
                        </td>
                        <td>
                            {{e.roleName}}
                        </td>
                        <td>
                            {{e.orgName }} ({{e.orgId}})
                        </td>
                        <td align="right">
                            <div class="row" style="margin: 0; justify-content: center;">
                                <button title="Edit" class="col-md-2  btn btn-outline-success btn-sm"
                                    (click)="get(e.id)">
                                    <i class="fa fa-edit"></i>
                                </button>
                                <button title="Delete" class="col-md-2 btn btn-outline-danger btn-sm"
                                    (click)="delete(e.id)">
                                    <i class="fa fa-archive"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</div>